export default {
  getOne: state => id => state.prestacoescontas.find(item => item.id === id),
}
